module.exports = __webpack_public_path__ + "img/img2.0cfd65f2.png";